import {
    TextHelper,
    //SmallTextHelper,
    UrlHelper,
    //ArrayHelper
} from '../../PrismicHelpers';

export const featuresSlice = (data) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = data.slice_type;
    // Non repetable data inside slice
    const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const sliceRepetableData = data.items;

    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        headline: TextHelper(sliceFixedData.headline),
        features: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            return {
                title: TextHelper(element.title),
                description: TextHelper(element.description),
                icon: UrlHelper(element.icon),
                link: UrlHelper(element.internal_link)
            }
        })
    };
    return dataToSend;
}



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/featuresSlice.js